import React from 'react';

const BidirectionalArrowIcon = (props) => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g>
        <path
          d='M25,16c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l3.3-3.3l-3.3-3.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l4,4
          c0.4,0.4,0.4,1,0,1.4l-4,4C25.5,15.9,25.3,16,25,16z'
        />
      </g>
      <g>
        <path d='M29,12H7c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S29.6,12,29,12z' />
      </g>
      <g>
        <path
          d='M7,26c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4l4-4c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L4.4,21l3.3,3.3
          c0.4,0.4,0.4,1,0,1.4C7.5,25.9,7.3,26,7,26z'
        />
      </g>
      <g>
        <path d='M25,22H3c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S25.6,22,25,22z' />
      </g>
    </svg>
  );
};

export default BidirectionalArrowIcon;
